<div class="ui basic segment">
    <app-header
        title="{{
            {
                key: 'payroll.records.payrollHoursAndDateRange',
                params: {
                    startDate: payroll.startDate | appDate: 'MMM d',
                    endDate: payroll.endDate | appDate: 'MMM d',
                },
            } | appTranslate
        }}"
        [badgeOptions]="{ label: 'payroll.records.paid', type: 'success' }"
        [back]="true"
        [backRoute]="['/payroll/records/payrolls']"
    >
    </app-header>
    <div class="app-grid">
        <app-table [table]="table" [showOffset]="false"></app-table>
    </div>
</div>
